import { Typography } from 'antd';
import User from '../../../models/User';
import './Header.less';

/**
 * @component Header.tsx
 * @description Header component
 * @return { Component }
 */
interface HeaderProps {
  user: User;
}
function Header(props: HeaderProps) {
  const { Title, Text } = Typography;
  const userName = `${props.user.nombre}  ${props.user.apellido}`;
  return (
    <div className="ml-header__content">
      <Title>
        Hola! {props.user.nombre !== '' ? userName : localStorage.getItem('userName')}
      </Title>
      <Text type="secondary" style={{fontSize: '16px'}}>¿Qué necesitas hacer hoy?</Text>
    </div>
  );
}

export default Header;
